// // import profile images
// import ProfilePhoto1 from '../src/assets/img/profile1.png';
// import ProfilePhoto2 from '../src/assets/img/profile2.png';
// import ProfilePhoto3 from '../src/assets/img/profile3.png';

// import about icons
import Skill1 from '../src/assets/img/skills/skill1.png';
import Skill2 from '../src/assets/img/skills/skill2.png';
import Skill3 from '../src/assets/img/skills/skill3.png';
import Skill4 from '../src/assets/img/skills/skill4.png';
import Skill5 from '../src/assets/img/skills/skill5.png';
import Skill6 from '../src/assets/img/skills/skill6.png';

// import team images
import TeamMember1 from '../src/assets/img/lawyer1.png';
import TeamMember2 from '../src/assets/img/lawyer2.png';
import TeamMember3 from '../src/assets/img/lawyer3.png';

// import social icons
import FacebookIcon from '../src/assets/img/social/facebook.png';
import TwitterIcon from '../src/assets/img/social/twitter.png';
import InstagramIcon from '../src/assets/img/social/instagram.png';
import YoutubeIcon from '../src/assets/img/social/youtube.png';
import PinterestIcon from '../src/assets/img/social/pinterest.png';

// navigation data
export const navigation = [
  {
    name: 'Home',
    href: 'home',
  },
  {
    name: 'What we do',
    href: 'skills',
  },
  {
    name: 'Our team',
    href: 'team',
  },
  {
    name: 'Contact us',
    href: 'contact',
  },
];

// testimonials data
export const testimonials = [
  {
    text: 'Thanks to Saurav Bhasin and Arvind Bhasin, I received exceptional legal support during my dispute. Their professionalism and expertise made all the difference. Highly recommended!',
    name: 'Vipin Makhija'
  },
  {
    text: 'Arvind Bhasin handled my 138 cheque bounce case with exceptional professionalism. He successfully helped recover funds that had been stuck for 3 to 5 years. I’m truly grateful for his expertise.',
    name: 'Deepansh Valecha'
  },
  {
    text: 'Saurav Bhasin provided outstanding legal support on my intellectual property matter, including filing my trademark and registering my incorporation. He also assisted in money recovery and other legal issues. Highly recommended!',
    name: 'Bharat Gupta'
  },
  {
    text: 'Arvind Bhasin assisted me with my marriage registration and resolved a family dispute matter efficiently. His professionalism and dedication provided the support I needed. I highly recommend his services.',
    name: 'Nidhi Singhal'
  },
  {
    text: 'Saurav Bhasin and Rashmi Gupta handled my prolonged family dispute and divorce matter with exceptional speed and professionalism. I was amazed by the quick resolution and the positive outcome. Highly recommended!',
    name: 'Mansi Sahani'
  },
];

// skills data
export const skills = [
  {
    icon: Skill1,
    title: 'Corruption',
    description:
      'Providing legal advice and representation in matters involving corruption, misconduct, and regulatory investigations, with a focus on compliance and due process.',
  },
  {
    icon: Skill2,
    title: 'Employment',
    description:
      'Advising employers and employees on employment contracts, workplace disputes, wrongful termination, and compliance with labour and employment laws.',
  },
  {
    icon: Skill3,
    title: 'Real Estate',
    description:
      'Assisting clients with residential and commercial real estate transactions, leasing, due diligence, and property-related legal matters.',
  },
  {
    icon: Skill4,
    title: 'Taxes',
    description:
      'Offering legal guidance on tax planning, compliance, disputes, and representation before tax authorities to ensure lawful and efficient outcomes.',
  },
  {
    icon: Skill5,
    title: 'Corporate',
    description:
      'Supporting businesses with incorporation, governance, contracts, mergers, acquisitions, and ongoing corporate compliance.',
  },
  {
    icon: Skill6,
    title: 'Banking',
    description:
      'Advising financial institutions and clients on banking regulations, financing transactions, loan documentation, and risk management matters.',
  },
];

// team data
export const team = [
  {
    image: TeamMember1,
    name: 'Saurav Bhasin',
    position: 'Principal Associate', 
    description:
      'With over 15 years of experience, Saurav Bhasin is the principal lawyer of our firm, specializing in Civil, Criminal, IP, Debt Recovery, Real Estate, and Corporate Law. He is empaneled with prominent institutions like Punjab National Bank, State Bank of India, Union Bank, and the Delhi Development Authority (DDA). Saurav is known for his expertise and commitment to delivering effective legal solutions to his clients.',
  },
  {
    image: TeamMember2,
    name: 'Rashmi Gupta',
    position: 'Senior Associate',
    description:
      'With extensive experience in litigation and legal research, Rashmi Gupta has specialized in Divorce Matters and Debt Recovery. Her keen legal acumen and dedication to her clients have earned her a solid reputation in handling family disputes and financial recovery cases. Rashmi\'s strategic approach and compassionate demeanor ensure that clients receive the highest level of professional care.',
  },
  {
    image: TeamMember3,
    name: 'Arvind Bhasin',
    position: 'Associate',
    description:
      'Arvind Bhasin completed his B.A. LL.B. from Guru Gobind Singh Indraprastha University (IP University), New Delhi, and brings over three years of practical legal experience. He has actively practiced before the Delhi High Court, various District Courts, and multiple tribunals, handling matters involving litigation, legal drafting, and case analysis. Known for his meticulous research skills and client-focused approach, Arvind is committed to delivering effective, ethical, and timely legal solutions.',
  },
];

// social data
export const social = [
  {
    icon: FacebookIcon,
  },
  {
    icon: TwitterIcon,
  },
  {
    icon: InstagramIcon,
  },
  {
    icon: YoutubeIcon,
  },
  {
    icon: PinterestIcon,
  },
];
